import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import EU_LOGO from 'app/components/panels/inp/pdf/assets/eu_logo.png';
import ECTRL_LOGO from 'app/components/panels/inp/pdf/assets/ectrl_logo.png';

export const Header = () => {
    return (
        <View fixed style={styles.header}>
            <Image style={styles.eu_logo} src={EU_LOGO} />
            <View style={styles.left_text}>
                <Text style={styles.nm}>Network Manager</Text>
                <Text>nominated by</Text>
                <Text>the European Comission</Text>
            </View>
            <Text style={styles.title}>Initial Network Plan</Text>
            <Image style={styles.logo} src={ECTRL_LOGO} />
        </View>
    );
};

const styles = StyleSheet.create({
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingBottom: '1px',
        borderBottom: '0.5px solid black',
    },
    eu_logo: {
        marginRight: 'auto',
        maxWidth: 70,
        maxHeight: 50,
        width: 'auto',
        height: 'auto',
    },
    nm: {
        fontSize: '15px',
        fontWeight: 'bold',
    },
    left_text: {
        marginRight: 'auto',
        paddingLeft: 5,
        fontSize: 12,
    },
    logo: {
        padding: '1px',
        width: 50,
        height: 50,
        marginLeft: 'auto',
    },
    title: {
        fontWeight: 'bold',
        paddingLeft: 10,
        fontSize: 20,
        left: '50%',
        flexGrow: 2,
    },
});
